import styled from 'styled-components';
import { CardInput } from '../CardInputs/CardsStyledComponents';

export const ModalContainer = styled.div`
  min-width: 660px;
  max-height: calc(90vh - 5vh);
  position: fixed;
  background-color: white;
  z-index: 99;
  top: 5vh;
  left: calc(50% - 330px);
  padding: 25px;
  border-radius: 16px;
  overflow-y:   auto;

  @media (max-width: 850px) {
    top: 0;
    left: 0;
    width: 100%;
    min-width: 100%;
    max-height: none;
    height: calc(100% - 480px);
    margin-top: 480px;
    border-radius: 16px 16px 0 0;
  }

  @media (max-height: 820px) and (orientation: portrait) {
    height: calc(100% - 320px);
    margin-top: 320px;
  }

  @media (max-height: 820px) and (orientation: landscape) {
    height: 100%;
    margin-top: 0px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const CardPartialPaymentHeader = styled(CardInput)`
  flex-direction: column;
  width: 100%;
  padding: 16px;
  background-color: ${(props) => props.theme.colors.gray12};
`;

export const DetailTextWrapper = styled.div`
  margin: 16px 0;
  line-height: 20px;
`;

export const DetailDescriptionText = styled.div`

`;

export const DetailPaymentList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

interface DetailPaymentRowProps {
    marginLeft?: string;
}

export const DetailPaymentRow = styled.div`
    display: flex;
    justify-content: space-between;
    margin-left: ${(props: DetailPaymentRowProps) => props.marginLeft ?? '0'};
`;